var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// src/Component.ts
import { observable, action, computed, runInAction } from "mobx";
var Component = class {
  constructor(data) {
    this.parent = null;
    this.id = data.id;
    this.type = data.type;
    this.name = data.name;
    this.description = data.description;
    this.comment = data.comment;
    this.tags = data.tags;
    const transform = data.layout?.transform || data.transform || {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0, w: 1 },
      scale: { x: 1, y: 1, z: 1 }
    };
    this.layout = observable({
      transform: {
        position: observable.object({ ...transform.position }),
        rotation: observable.object({ ...transform.rotation }),
        scale: observable.object({ ...transform.scale })
      },
      ...data.layout?.hidden && { hidden: data.layout.hidden }
    });
    this.metadata = data.metadata ? observable({ ...data.metadata }) : void 0;
    this.manufacturing_steps = data.manufacturing_steps ? observable([...data.manufacturing_steps]) : void 0;
  }
  setName(name) {
    this.name = name;
  }
  setDescription(description) {
    this.description = description;
  }
  setComment(comment) {
    this.comment = comment;
  }
  setTags(tags) {
    this.tags = tags;
  }
  addTag(tag) {
    if (!this.tags) {
      this.tags = [];
    }
    if (!this.tags.includes(tag)) {
      this.tags.push(tag);
    }
  }
  removeTag(tag) {
    if (this.tags) {
      const index = this.tags.indexOf(tag);
      if (index > -1) {
        this.tags.splice(index, 1);
      }
    }
  }
  setPosition(x, y, z) {
    runInAction(() => {
      this.layout.transform.position.x = x;
      this.layout.transform.position.y = y;
      this.layout.transform.position.z = z;
    });
  }
  setRotation(x, y, z, w) {
    runInAction(() => {
      this.layout.transform.rotation.x = x;
      this.layout.transform.rotation.y = y;
      this.layout.transform.rotation.z = z;
      this.layout.transform.rotation.w = w;
    });
  }
  setScale(x, y, z) {
    runInAction(() => {
      this.layout.transform.scale.x = x;
      this.layout.transform.scale.y = y;
      this.layout.transform.scale.z = z;
    });
  }
  setVisibility(hidden) {
    if (hidden) {
      this.layout.hidden = hidden;
    } else {
      delete this.layout.hidden;
    }
  }
  setTransform(transform) {
    if (transform.position) {
      this.setPosition(
        transform.position.x,
        transform.position.y,
        transform.position.z
      );
    }
    if (transform.rotation) {
      this.setRotation(
        transform.rotation.x,
        transform.rotation.y,
        transform.rotation.z,
        transform.rotation.w
      );
    }
    if (transform.scale) {
      this.setScale(
        transform.scale.x,
        transform.scale.y,
        transform.scale.z
      );
    }
  }
  get transform() {
    return this.layout.transform;
  }
  setMetadata(key, value) {
    if (!this.metadata) {
      this.metadata = observable({});
    }
    this.metadata[key] = value;
  }
  removeMetadata(key) {
    if (this.metadata) {
      delete this.metadata[key];
      if (Object.keys(this.metadata).length === 0) {
        this.metadata = void 0;
      }
    }
  }
  addChild(key, child) {
    if (!this.children) {
      this.children = observable({});
    }
    child.parent = this;
    this.children[key] = child;
  }
  removeChild(key) {
    if (this.children) {
      const child = this.children[key];
      if (child) {
        child.parent = null;
        delete this.children[key];
        if (Object.keys(this.children).length === 0) {
          this.children = void 0;
        }
      }
    }
  }
  addManufacturingStep(step) {
    if (!this.manufacturing_steps) {
      this.manufacturing_steps = observable([]);
    }
    this.manufacturing_steps.push(step);
    this.manufacturing_steps.sort((a, b) => a.order - b.order);
  }
  removeManufacturingStep(stepId) {
    if (this.manufacturing_steps) {
      const index = this.manufacturing_steps.findIndex((s) => s.id === stepId);
      if (index > -1) {
        this.manufacturing_steps.splice(index, 1);
        if (this.manufacturing_steps.length === 0) {
          this.manufacturing_steps = void 0;
        }
      }
    }
  }
  get worldTransform() {
    if (!this.parent) {
      return this.transform;
    }
    return this.transform;
  }
};
__decorateClass([
  observable
], Component.prototype, "id", 2);
__decorateClass([
  observable
], Component.prototype, "type", 2);
__decorateClass([
  observable
], Component.prototype, "name", 2);
__decorateClass([
  observable
], Component.prototype, "description", 2);
__decorateClass([
  observable
], Component.prototype, "comment", 2);
__decorateClass([
  observable
], Component.prototype, "tags", 2);
__decorateClass([
  observable
], Component.prototype, "layout", 2);
__decorateClass([
  observable
], Component.prototype, "metadata", 2);
__decorateClass([
  observable
], Component.prototype, "children", 2);
__decorateClass([
  observable
], Component.prototype, "manufacturing_steps", 2);
__decorateClass([
  action
], Component.prototype, "setName", 1);
__decorateClass([
  action
], Component.prototype, "setDescription", 1);
__decorateClass([
  action
], Component.prototype, "setComment", 1);
__decorateClass([
  action
], Component.prototype, "setTags", 1);
__decorateClass([
  action
], Component.prototype, "addTag", 1);
__decorateClass([
  action
], Component.prototype, "removeTag", 1);
__decorateClass([
  action
], Component.prototype, "setPosition", 1);
__decorateClass([
  action
], Component.prototype, "setRotation", 1);
__decorateClass([
  action
], Component.prototype, "setScale", 1);
__decorateClass([
  action
], Component.prototype, "setVisibility", 1);
__decorateClass([
  action
], Component.prototype, "setTransform", 1);
__decorateClass([
  computed
], Component.prototype, "transform", 1);
__decorateClass([
  action
], Component.prototype, "setMetadata", 1);
__decorateClass([
  action
], Component.prototype, "removeMetadata", 1);
__decorateClass([
  action
], Component.prototype, "addChild", 1);
__decorateClass([
  action
], Component.prototype, "removeChild", 1);
__decorateClass([
  action
], Component.prototype, "addManufacturingStep", 1);
__decorateClass([
  action
], Component.prototype, "removeManufacturingStep", 1);
__decorateClass([
  computed
], Component.prototype, "worldTransform", 1);

// src/Panel.ts
import { observable as observable2, action as action2 } from "mobx";
var Panel = class extends Component {
  constructor(data) {
    super(data);
    this.geometry = observable2({ ...data.geometry });
    this.material = observable2({ ...data.material });
    this.edge_banding = data.edge_banding ? observable2({ ...data.edge_banding }) : void 0;
    this.grain_direction = data.grain_direction;
  }
  setGeometry(geometry) {
    Object.assign(this.geometry, geometry);
  }
  setMaterial(material) {
    Object.assign(this.material, material);
  }
  setEdgeBanding(edge_banding) {
    this.edge_banding = edge_banding ? observable2({ ...edge_banding }) : void 0;
  }
  setGrainDirection(direction) {
    this.grain_direction = direction;
  }
  toSchema() {
    return {
      id: this.id,
      type: "panel",
      name: this.name,
      description: this.description,
      comment: this.comment,
      tags: this.tags,
      layout: {
        transform: { ...this.layout.transform },
        ...this.layout.hidden && { hidden: this.layout.hidden }
      },
      metadata: this.metadata ? { ...this.metadata } : void 0,
      geometry: { ...this.geometry },
      material: { ...this.material },
      edge_banding: this.edge_banding ? { ...this.edge_banding } : void 0,
      grain_direction: this.grain_direction,
      children: this.children ? Object.fromEntries(
        Object.entries(this.children).map(([key, child]) => [key, child.toSchema()])
      ) : void 0,
      manufacturing_steps: this.manufacturing_steps ? [...this.manufacturing_steps] : void 0
    };
  }
};
__decorateClass([
  observable2
], Panel.prototype, "geometry", 2);
__decorateClass([
  observable2
], Panel.prototype, "material", 2);
__decorateClass([
  observable2
], Panel.prototype, "edge_banding", 2);
__decorateClass([
  observable2
], Panel.prototype, "grain_direction", 2);
__decorateClass([
  action2
], Panel.prototype, "setGeometry", 1);
__decorateClass([
  action2
], Panel.prototype, "setMaterial", 1);
__decorateClass([
  action2
], Panel.prototype, "setEdgeBanding", 1);
__decorateClass([
  action2
], Panel.prototype, "setGrainDirection", 1);

// src/Lumber.ts
import { makeAutoObservable, observable as observable3 } from "mobx";
var Lumber = class extends Component {
  constructor(data) {
    super(data);
    this.geometry = observable3({ ...data.geometry });
    this.material = observable3({ ...data.material });
    this.nominal_size = data.nominal_size;
    this.actual_dimensions = observable3({ ...data.actual_dimensions });
    makeAutoObservable(this);
  }
  toSchema() {
    return {
      id: this.id,
      type: "lumber",
      name: this.name,
      description: this.description,
      comment: this.comment,
      tags: this.tags,
      layout: {
        transform: { ...this.layout.transform },
        ...this.layout.hidden && { hidden: this.layout.hidden }
      },
      metadata: this.metadata ? { ...this.metadata } : void 0,
      geometry: { ...this.geometry },
      material: { ...this.material },
      nominal_size: this.nominal_size,
      actual_dimensions: { ...this.actual_dimensions },
      children: this.children ? Object.fromEntries(
        Object.entries(this.children).map(([key, child]) => [key, child.toSchema()])
      ) : void 0,
      manufacturing_steps: this.manufacturing_steps ? [...this.manufacturing_steps] : void 0
    };
  }
};
__decorateClass([
  observable3
], Lumber.prototype, "geometry", 2);
__decorateClass([
  observable3
], Lumber.prototype, "material", 2);
__decorateClass([
  observable3
], Lumber.prototype, "nominal_size", 2);
__decorateClass([
  observable3
], Lumber.prototype, "actual_dimensions", 2);

// src/Hardware.ts
import { observable as observable4 } from "mobx";
var Hardware = class extends Component {
  constructor(data) {
    super(data);
    this.hardware_type = data.hardware_type;
    this.specifications = observable4({ ...data.specifications });
    this.material = observable4({ ...data.material });
    this.quantity = data.quantity;
    this.manufacturer = data.manufacturer;
    this.model_number = data.model_number;
    this.supplier_sku = data.supplier_sku;
    this.cost = data.cost;
  }
  toSchema() {
    return {
      id: this.id,
      type: "hardware",
      name: this.name,
      description: this.description,
      comment: this.comment,
      tags: this.tags,
      layout: {
        transform: { ...this.layout.transform },
        ...this.layout.hidden && { hidden: this.layout.hidden }
      },
      metadata: this.metadata ? { ...this.metadata } : void 0,
      hardware_type: this.hardware_type,
      specifications: { ...this.specifications },
      material: { ...this.material },
      quantity: this.quantity,
      manufacturer: this.manufacturer,
      model_number: this.model_number,
      supplier_sku: this.supplier_sku,
      cost: this.cost,
      children: this.children ? Object.fromEntries(
        Object.entries(this.children).map(([key, child]) => [key, child.toSchema()])
      ) : void 0,
      manufacturing_steps: this.manufacturing_steps ? [...this.manufacturing_steps] : void 0
    };
  }
};
__decorateClass([
  observable4
], Hardware.prototype, "hardware_type", 2);
__decorateClass([
  observable4
], Hardware.prototype, "specifications", 2);
__decorateClass([
  observable4
], Hardware.prototype, "material", 2);
__decorateClass([
  observable4
], Hardware.prototype, "quantity", 2);
__decorateClass([
  observable4
], Hardware.prototype, "manufacturer", 2);
__decorateClass([
  observable4
], Hardware.prototype, "model_number", 2);
__decorateClass([
  observable4
], Hardware.prototype, "supplier_sku", 2);
__decorateClass([
  observable4
], Hardware.prototype, "cost", 2);

// src/Group.ts
import { observable as observable5 } from "mobx";
var Group = class extends Component {
  constructor(data) {
    super(data);
    this.legacyChildren = data.legacyChildren;
  }
  toSchema() {
    return {
      id: this.id,
      type: "group",
      name: this.name,
      description: this.description,
      comment: this.comment,
      tags: this.tags,
      layout: {
        transform: { ...this.layout.transform },
        ...this.layout.hidden && { hidden: this.layout.hidden }
      },
      metadata: this.metadata ? { ...this.metadata } : void 0,
      children: this.children ? Object.fromEntries(
        Object.entries(this.children).map(([key, child]) => [key, child.toSchema()])
      ) : void 0,
      legacyChildren: this.legacyChildren,
      manufacturing_steps: this.manufacturing_steps ? [...this.manufacturing_steps] : void 0
    };
  }
};
__decorateClass([
  observable5
], Group.prototype, "legacyChildren", 2);

// src/Dowel.ts
import { makeAutoObservable as makeAutoObservable2, observable as observable6 } from "mobx";
var Dowel = class extends Component {
  constructor(data) {
    super(data);
    this.geometry = observable6({ ...data.geometry });
    this.material = observable6({ ...data.material });
    this.length = data.length;
    this.diameter = data.diameter;
    makeAutoObservable2(this);
  }
  toSchema() {
    return {
      id: this.id,
      type: "dowel",
      name: this.name,
      description: this.description,
      comment: this.comment,
      tags: this.tags,
      layout: {
        transform: { ...this.layout.transform },
        ...this.layout.hidden && { hidden: this.layout.hidden }
      },
      metadata: this.metadata ? { ...this.metadata } : void 0,
      geometry: { ...this.geometry },
      material: { ...this.material },
      length: this.length,
      diameter: this.diameter,
      children: this.children ? Object.fromEntries(
        Object.entries(this.children).map(([key, child]) => [key, child.toSchema()])
      ) : void 0,
      manufacturing_steps: this.manufacturing_steps ? [...this.manufacturing_steps] : void 0
    };
  }
};
__decorateClass([
  observable6
], Dowel.prototype, "geometry", 2);
__decorateClass([
  observable6
], Dowel.prototype, "material", 2);
__decorateClass([
  observable6
], Dowel.prototype, "length", 2);
__decorateClass([
  observable6
], Dowel.prototype, "diameter", 2);

// src/Assembly.ts
import { makeAutoObservable as makeAutoObservable3, observable as observable7, action as action3, computed as computed2, reaction } from "mobx";
import { v4 as uuid } from "uuid";

// src/fromSchema.ts
function fromSchema(data) {
  let component;
  switch (data.type) {
    case "panel":
      component = new Panel(data);
      break;
    case "lumber":
      component = new Lumber(data);
      break;
    case "hardware":
      component = new Hardware(data);
      break;
    case "group":
      component = new Group(data);
      break;
    case "dowel":
      component = new Dowel(data);
      break;
    default:
      throw new Error(`Unknown component type: ${data.type}`);
  }
  if (data.children) {
    Object.entries(data.children).forEach(([key, childSchema]) => {
      const childComponent = fromSchema(childSchema);
      component.addChild(key, childComponent);
    });
  }
  return component;
}
Component.fromSchema = fromSchema;

// src/Assembly.ts
var Assembly = class {
  constructor(data) {
    this.components = observable7.map();
    this.selectedComponentIds = observable7.set();
    this.hoveredComponentId = null;
    this.transformMode = null;
    this.snapToGrid = true;
    this.gridSize = 0.05;
    this.showBounds = false;
    this.showJoinery = true;
    this.joinery = [];
    this.tags = [];
    this.metadata = {};
    this.history = [];
    this.historyIndex = -1;
    this.maxHistorySize = 50;
    if (data) {
      this.loadFromSchema(data);
    } else {
      this.id = uuid();
      this.name = "Untitled Project";
      this.version = "1.0.0";
      this.created_at = (/* @__PURE__ */ new Date()).toISOString();
      this.updated_at = (/* @__PURE__ */ new Date()).toISOString();
    }
    makeAutoObservable3(this);
    this.setupReactions();
  }
  setupReactions() {
    reaction(
      () => this.toSchema(),
      (serialized) => {
        localStorage.setItem("fabrick_autosave", JSON.stringify(serialized));
      },
      { delay: 1e3 }
    );
  }
  loadFromSchema(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.version = data.version;
    this.author = data.author;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.joinery = data.joinery || [];
    this.tags = data.tags || [];
    this.category = data.category;
    this.metadata = { ...data.metadata || {} };
    this.components.clear();
    const uniqueComponents = /* @__PURE__ */ new Map();
    for (const component of data.components) {
      if (!uniqueComponents.has(component.id)) {
        uniqueComponents.set(component.id, fromSchema(component));
      }
    }
    for (const component of data.components) {
      const obsComponent = uniqueComponents.get(component.id);
      if (component.children) {
        Object.entries(component.children).forEach(([key, child]) => {
          const childComponent = uniqueComponents.get(child.id);
          if (childComponent) {
            obsComponent.addChild(key, childComponent);
          }
        });
      }
      if (component.type === "group") {
        const group = component;
        if (group.legacyChildren) {
          group.legacyChildren.forEach((child) => {
            const childComponent = uniqueComponents.get(child.id);
            if (childComponent) {
              obsComponent.addChild(child.id, childComponent);
            }
          });
        }
      }
    }
    Array.from(uniqueComponents.values()).filter((c) => !c.parent).forEach((c) => this.components.set(c.id, c));
    uniqueComponents.forEach((c, id) => {
      if (!this.components.has(id)) {
        this.components.set(id, c);
      }
    });
    this.saveToHistory();
  }
  addComponent(component) {
    if (this.components.has(component.id)) {
      return;
    }
    this.components.set(component.id, component);
    if (component.children) {
      Object.values(component.children).forEach((child) => {
        this.addComponent(child);
      });
    }
    this.updated_at = (/* @__PURE__ */ new Date()).toISOString();
  }
  removeComponent(componentId) {
    const component = this.components.get(componentId);
    if (component) {
      if (component.parent && component.parent.children) {
        Object.entries(component.parent.children).filter(([_, child]) => child.id === componentId).forEach(([key]) => component.parent.removeChild(key));
      }
      const removeRecursive = (c) => {
        if (c.children) {
          Object.values(c.children).forEach((child) => {
            removeRecursive(child);
            this.components.delete(child.id);
          });
        }
      };
      removeRecursive(component);
      this.components.delete(componentId);
      this.selectedComponentIds.delete(componentId);
      this.updated_at = (/* @__PURE__ */ new Date()).toISOString();
      this.saveToHistory();
    }
  }
  moveComponentToGroup(componentId, groupId, key) {
    const component = this.components.get(componentId);
    const group = this.components.get(groupId);
    if (!component || !group || group.type !== "group") {
      return;
    }
    const componentTransform = component.layout?.transform || component.transform;
    const groupTransform = group.layout?.transform || group.transform;
    let worldX = componentTransform.position.x;
    let worldY = componentTransform.position.y;
    let worldZ = componentTransform.position.z;
    if (component.parent) {
      const parentTransform = component.parent.layout?.transform || component.parent.transform;
      worldX += parentTransform.position.x;
      worldY += parentTransform.position.y;
      worldZ += parentTransform.position.z;
      if (component.parent.children) {
        for (const [childKey2, child] of Object.entries(component.parent.children)) {
          if (child.id === componentId) {
            component.parent.removeChild(childKey2);
            break;
          }
        }
      }
    }
    const relativeX = worldX - groupTransform.position.x;
    const relativeY = worldY - groupTransform.position.y;
    const relativeZ = worldZ - groupTransform.position.z;
    componentTransform.position.x = relativeX;
    componentTransform.position.y = relativeY;
    componentTransform.position.z = relativeZ;
    const childKey = key || component.name || component.id;
    group.addChild(childKey, component);
    this.updated_at = (/* @__PURE__ */ new Date()).toISOString();
    this.saveToHistory();
  }
  removeComponentFromGroup(componentId) {
    const component = this.components.get(componentId);
    if (!component || !component.parent) {
      return;
    }
    const componentTransform = component.layout?.transform || component.transform;
    const parentTransform = component.parent.layout?.transform || component.parent.transform;
    const worldX = componentTransform.position.x + parentTransform.position.x;
    const worldY = componentTransform.position.y + parentTransform.position.y;
    const worldZ = componentTransform.position.z + parentTransform.position.z;
    if (component.parent.children) {
      for (const [key, child] of Object.entries(component.parent.children)) {
        if (child.id === componentId) {
          component.parent.removeChild(key);
          break;
        }
      }
    }
    componentTransform.position.x = worldX;
    componentTransform.position.y = worldY;
    componentTransform.position.z = worldZ;
    if (!this.components.has(componentId)) {
      this.components.set(componentId, component);
    }
    this.updated_at = (/* @__PURE__ */ new Date()).toISOString();
    this.saveToHistory();
  }
  duplicateComponent(componentId) {
    const component = this.components.get(componentId);
    if (!component) return;
    const schema = component.toSchema();
    const duplicate = fromSchema({
      ...schema,
      id: uuid(),
      layout: {
        transform: {
          ...schema.layout.transform,
          position: {
            x: schema.layout.transform.position.x + 0.1,
            y: schema.layout.transform.position.y,
            z: schema.layout.transform.position.z + 0.1
          }
        },
        ...schema.layout.hidden && { hidden: schema.layout.hidden }
      }
    });
    this.addComponent(duplicate);
    this.selectComponent(duplicate.id, false);
  }
  selectComponent(componentId, addToSelection = false) {
    if (!addToSelection) {
      if (this.selectedComponentIds.has(componentId) && this.selectedComponentIds.size === 1) {
        return;
      }
      this.selectedComponentIds.clear();
    } else {
      if (this.selectedComponentIds.has(componentId)) {
        this.selectedComponentIds.delete(componentId);
        return;
      }
    }
    this.selectedComponentIds.add(componentId);
    this.transformMode = null;
  }
  deselectComponent(componentId) {
    this.selectedComponentIds.delete(componentId);
  }
  clearSelection() {
    this.selectedComponentIds.clear();
    this.transformMode = null;
  }
  setHoveredComponent(componentId) {
    this.hoveredComponentId = componentId;
  }
  setTransformMode(mode) {
    this.transformMode = mode;
  }
  toggleSnapToGrid() {
    this.snapToGrid = !this.snapToGrid;
  }
  setGridSize(size) {
    this.gridSize = size;
  }
  get selectedComponents() {
    return Array.from(this.selectedComponentIds).map((id) => this.components.get(id)).filter((c) => c !== void 0);
  }
  get componentCount() {
    return this.components.size;
  }
  get hasSelection() {
    return this.selectedComponentIds.size > 0;
  }
  get rootComponents() {
    return Array.from(this.components.values()).filter((component) => !component.parent);
  }
  get bounds() {
    const components = this.rootComponents;
    if (components.length === 0) {
      return void 0;
    }
    let minX = Infinity, minY = Infinity, minZ = Infinity;
    let maxX = -Infinity, maxY = -Infinity, maxZ = -Infinity;
    const calculateBounds = (component) => {
      const pos = component.transform.position;
      let halfSize;
      if (component.type === "panel" || component.type === "lumber") {
        const geom = component.geometry;
        halfSize = {
          x: geom.width / 2,
          y: geom.height / 2,
          z: geom.depth / 2
        };
      } else {
        halfSize = { x: 0.05, y: 0.05, z: 0.05 };
      }
      minX = Math.min(minX, pos.x - halfSize.x);
      minY = Math.min(minY, pos.y - halfSize.y);
      minZ = Math.min(minZ, pos.z - halfSize.z);
      maxX = Math.max(maxX, pos.x + halfSize.x);
      maxY = Math.max(maxY, pos.y + halfSize.y);
      maxZ = Math.max(maxZ, pos.z + halfSize.z);
      if (component.children) {
        Object.values(component.children).forEach((child) => calculateBounds(child));
      }
    };
    components.forEach(calculateBounds);
    return {
      min: { x: minX, y: minY, z: minZ },
      max: { x: maxX, y: maxY, z: maxZ },
      dimensions: {
        x: maxX - minX,
        y: maxY - minY,
        z: maxZ - minZ
      }
    };
  }
  undo() {
    if (this.historyIndex > 0) {
      this.historyIndex--;
      this.loadFromSchema(this.history[this.historyIndex]);
    }
  }
  redo() {
    if (this.historyIndex < this.history.length - 1) {
      this.historyIndex++;
      this.loadFromSchema(this.history[this.historyIndex]);
    }
  }
  get canUndo() {
    return this.historyIndex > 0;
  }
  get canRedo() {
    return this.historyIndex < this.history.length - 1;
  }
  saveToHistory() {
    if (this.historyIndex < this.history.length - 1) {
      this.history = this.history.slice(0, this.historyIndex + 1);
    }
    this.history.push(this.toSchema());
    this.historyIndex = this.history.length - 1;
    if (this.history.length > this.maxHistorySize) {
      this.history.shift();
      this.historyIndex--;
    }
  }
  toSchema() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      version: this.version,
      author: this.author,
      created_at: this.created_at,
      updated_at: this.updated_at,
      components: this.rootComponents.filter((c) => c && typeof c.toSchema === "function").map((c) => c.toSchema()),
      joinery: this.joinery,
      bounds: this.bounds,
      tags: this.tags,
      category: this.category,
      metadata: this.metadata
    };
  }
  exportToJSON() {
    return JSON.stringify(this.toSchema(), null, 2);
  }
  importFromJSON(json) {
    const data = JSON.parse(json);
    this.loadFromSchema(data);
  }
};
__decorateClass([
  observable7
], Assembly.prototype, "id", 2);
__decorateClass([
  observable7
], Assembly.prototype, "name", 2);
__decorateClass([
  observable7
], Assembly.prototype, "description", 2);
__decorateClass([
  observable7
], Assembly.prototype, "version", 2);
__decorateClass([
  observable7
], Assembly.prototype, "author", 2);
__decorateClass([
  observable7
], Assembly.prototype, "created_at", 2);
__decorateClass([
  observable7
], Assembly.prototype, "updated_at", 2);
__decorateClass([
  observable7
], Assembly.prototype, "components", 2);
__decorateClass([
  observable7
], Assembly.prototype, "selectedComponentIds", 2);
__decorateClass([
  observable7
], Assembly.prototype, "hoveredComponentId", 2);
__decorateClass([
  observable7
], Assembly.prototype, "transformMode", 2);
__decorateClass([
  observable7
], Assembly.prototype, "snapToGrid", 2);
__decorateClass([
  observable7
], Assembly.prototype, "gridSize", 2);
__decorateClass([
  observable7
], Assembly.prototype, "showBounds", 2);
__decorateClass([
  observable7
], Assembly.prototype, "showJoinery", 2);
__decorateClass([
  observable7
], Assembly.prototype, "joinery", 2);
__decorateClass([
  observable7
], Assembly.prototype, "tags", 2);
__decorateClass([
  observable7
], Assembly.prototype, "category", 2);
__decorateClass([
  observable7
], Assembly.prototype, "metadata", 2);
__decorateClass([
  action3
], Assembly.prototype, "loadFromSchema", 1);
__decorateClass([
  action3
], Assembly.prototype, "addComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "removeComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "moveComponentToGroup", 1);
__decorateClass([
  action3
], Assembly.prototype, "removeComponentFromGroup", 1);
__decorateClass([
  action3
], Assembly.prototype, "duplicateComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "selectComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "deselectComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "clearSelection", 1);
__decorateClass([
  action3
], Assembly.prototype, "setHoveredComponent", 1);
__decorateClass([
  action3
], Assembly.prototype, "setTransformMode", 1);
__decorateClass([
  action3
], Assembly.prototype, "toggleSnapToGrid", 1);
__decorateClass([
  action3
], Assembly.prototype, "setGridSize", 1);
__decorateClass([
  computed2
], Assembly.prototype, "selectedComponents", 1);
__decorateClass([
  computed2
], Assembly.prototype, "componentCount", 1);
__decorateClass([
  computed2
], Assembly.prototype, "hasSelection", 1);
__decorateClass([
  computed2
], Assembly.prototype, "rootComponents", 1);
__decorateClass([
  computed2
], Assembly.prototype, "bounds", 1);
__decorateClass([
  action3
], Assembly.prototype, "undo", 1);
__decorateClass([
  action3
], Assembly.prototype, "redo", 1);
__decorateClass([
  computed2
], Assembly.prototype, "canUndo", 1);
__decorateClass([
  computed2
], Assembly.prototype, "canRedo", 1);
__decorateClass([
  action3
], Assembly.prototype, "exportToJSON", 1);
__decorateClass([
  action3
], Assembly.prototype, "importFromJSON", 1);
export {
  Assembly,
  Component,
  Dowel,
  Group,
  Hardware,
  Lumber,
  Panel,
  fromSchema
};
//# sourceMappingURL=index.mjs.map